import React, {useState} from 'react';
import propTypes from 'prop-types';
import './index.css';
import Translate from "../../../../../components/Translate";
import TableHeaderSort from "../../../../../components-new/table/TableHeaderSort";
import PlatformIcon from "../../../../../components-new/general/PlatformIcon";
import TableAction from "../../../../../components-new/table/TableAction";
import TableDateTime from "../../../../../components-new/table/TableDateTime";
import LoadingComponent from "../../../../../components-new/ui/LoadingComponent";
import Colors from "../../../../../utils/Colors";
import colors from "../../../../../utils/Colors";
import BlockUserModal from "../../chat/chat-components/BlockUserModal";
import TableScroll from "../../../../../components-new/table/TableScroll";
import Tooltip from "../../../../../components-new/general/Tooltip";
import PersonOffIcon from "../../../../../assets/icons/PersonOffIcon";
import SpeakerNotesIcon from "../../../../../assets/icons/SpeakerNotesIcon";
import {hasManagementPermission} from "../../../../../utils/General";

const headers = [
    {translateKey: 'user', sortColumn: 'user.firstName,user.lastName'},
    {translateKey: 'bot', sortColumn: 'companyInfo.companyName'},
    {translateKey: 'operator', sortColumn: 'lastOperator.firstName,lastOperator.lastName'},
    {translateKey: 'platform', sortColumn: 'platform'},
    {translateKey: 'Status', sortColumn: 'status'},
    {translateKey: 'lastModifiedAt', sortColumn: 'lastModifiedAt'},
    {translateKey: 'createdAt', sortColumn: 'createdAt'},
    {translateKey: '', key: 'actions'},
]

const HistoryTable = ({
                          conversationsList,
                          showConversationHistory,
                          openTrModal,
                          openOperatorProfile,
                          onSort,
                          pageable,
                          isFetching,
                          addNotification,
                          user
                      }) => {

    const [isBlockUserModalOpen, setIsBlockUserModalOpen] = useState(false);
    const [blockConversation, setBlockConversation] = useState({});
    const canViewOperatorProfile = user && user.authorities && hasManagementPermission(user);
    return (
        <TableScroll className="history-table-scroll" stickyActions>
            <table className="custom-table history-table">
                <thead>
                <tr>
                    {headers.map((header, index) => (
                        <th
                            key={header.key || header.translateKey}
                            onClick={() => header.sortColumn && onSort(header.sortColumn)}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                justifyContent: index === headers.length - 1 ? 'center' : 'start',
                            }}>
                                <span className="history-table__header-label">
                                    {header.translateKey && <Translate text={header.translateKey}/>}
                                </span>
                                {
                                    header.sortColumn
                                    &&
                                    <TableHeaderSort
                                        isActive={pageable.sort.split(',').slice(0, -1).join(',') === header.sortColumn}
                                        direction={pageable.sort.split(',').pop()}
                                        style={{flexShrink: 0}}
                                    />
                                }

                            </div>
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody style={{height: '100%'}}>
                {
                    isFetching ?
                        <tr className="table-loading" style={{height: '100%'}}>
                            <td colSpan={8} style={{height: '100%'}}>
                                <LoadingComponent containerStyles={{margin: '100px 0'}}/>
                            </td>
                        </tr>
                        :
                        conversationsList.length === 0 ?
                            <tr className="table-no-result">
                                <td colSpan={8}
                                    style={{textAlign: 'center', padding: '300px', color: Colors.silverWhiteSemiDark}}>
                                    <Translate text={'noResultsFound'}/>
                                </td>
                            </tr>
                            :
                            conversationsList.map((conversation) => {
                                return (
                                    <tr
                                        key={conversation.id}
                                        onClick={() => openTrModal(conversation, showConversationHistory)}
                                    >
                                        <td style={{wordBreak: 'break-word'}}>
                                            {conversation.customerName}
                                        </td>

                                        <td>
                                            <span className="history-table__ellipsis">
                                                {conversation.botName}
                                            </span>
                                        </td>

                                        <td>
                                            {canViewOperatorProfile && conversation.operatorId ? (
                                                <button
                                                    type="button"
                                                    className="history-table__operator-button"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        openOperatorProfile(conversation);
                                                    }}
                                                >
                                                    {conversation.operatorFullName}
                                                </button>
                                            ) : (
                                                conversation.operatorFullName
                                            )}
                                        </td>

                                        <td>
                                            {/* the icon alone made the reader
                                                remember which logo is which;
                                                the name says it outright */}
                                            <div className="platform-cell">
                                                <PlatformIcon conversation={conversation} size={22}/>
                                                <span className="platform-cell__name">
                                                    {conversation.platform.charAt(0).toUpperCase() + conversation.platform.slice(1).toLowerCase()}
                                                </span>
                                            </div>
                                        </td>

                                        <td>
                                            {/* One line with an ellipsis. The table
                                                is table-layout: fixed, so a long
                                                status - and in Armenian they are
                                                long - wrapped to two and three
                                                lines, every row grew, and the page
                                                itself started scrolling. */}
                                            <Tooltip text={conversation.status}>
                                                <span className="history-table__ellipsis">
                                                    <Translate text={conversation.status}/>
                                                </span>
                                            </Tooltip>
                                        </td>

                                        <td>
                                            <TableDateTime value={conversation.lastModifiedAt}/>
                                        </td>

                                        <td>
                                            <TableDateTime value={conversation.createdAt}/>
                                        </td>

                                        <td>
                                            {/*
                                              * A plain cell with the buttons in a
                                              * div. display: flex on a <td> takes
                                              * it out of the table layout - it
                                              * stops sharing the row's height and
                                              * draws as a block of its own.
                                              */}
                                            <div className="table-actions">
                                                <TableAction
                                                    tooltip={'chatHistory'}
                                                    onClick={() => showConversationHistory(conversation)}
                                                    icon={<SpeakerNotesIcon width={18} height={18}/>}
                                                />

                                                <TableAction
                                                    tone="danger"
                                                    tooltip={'blockUser'}
                                                    onClick={() => {
                                                        setIsBlockUserModalOpen(true);
                                                        setBlockConversation(conversation);
                                                    }}
                                                    icon={<PersonOffIcon width={18} height={18} fill={colors.red}/>}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                }

                </tbody>
            </table>

            {isBlockUserModalOpen &&
                <BlockUserModal
                    isOpen={isBlockUserModalOpen}
                    cancelAction={() => setIsBlockUserModalOpen(false)}
                    conversation={{
                        id: blockConversation.conversationId,
                        platform: blockConversation.platform,
                        userId: blockConversation.userId,
                        companyId: blockConversation.companyId,
                    }}
                />
            }

        </TableScroll>
    );
};

HistoryTable.propTypes = {
    conversationsList: propTypes.array.isRequired,
    showConversationHistory: propTypes.func.isRequired,
    openTrModal: propTypes.func.isRequired,
    openOperatorProfile: propTypes.func.isRequired,
};

export default HistoryTable;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/HistoryTable.jsx